import styled from "styled-components";

export const UserParent = styled.div`
  display: flex;
  width: 120vw;
  height: 100vh;
  background:#F5F5F5;
`;

export const MainContentArea = styled.div`
  flex: 1;
  border: 1px solid #D9D9D9;
  display: flex;
  flex-direction: column;
`;

export const DashboardHeader = styled.header`
  width: 100%;
  height: 10%;
  border-bottom: 1px solid #D9D9D9;
`;

